export default __webpack_public_path__ + "static/media/img--section.e0caa2cf.jpg";